// extracted by mini-css-extract-plugin
module.exports = {"power-ocean-collection-M":"M_power-ocean-collection-M__XsuJa"};